import React, { useEffect, useState } from "react";
import api from "../../../data/api/mainApi";
import MillingStretchOverlay from "./MillingStretchOverlay";
import MillingContourEditor from "./MillingContourEditor";

export default function MillingImage({ imageKey, file, name = "Marásminta", stretch, enlarged = false }) {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    let objectUrl;
    setUrl("");
    setFailed(false);
    const show = (blob) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    };
    if (file) show(file);
    else if (imageKey) api.get(`/millings/images/${encodeURIComponent(imageKey)}`, { responseType: "blob" })
      .then(({ data }) => show(data)).catch(() => { if (active) setFailed(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [imageKey, file]);
  if (url && stretch) return <div style={{ position: "relative", display: "inline-block", maxWidth: "100%", lineHeight: 0 }}>
    <img src={url} alt={name} style={{ display: "block", width: "auto", height: "auto", maxWidth: "100%", maxHeight: 360 }} />
    <MillingStretchOverlay stretchX={stretch.stretchX} stretchY={stretch.stretchY} repeatX={stretch.repeatX} repeatY={stretch.repeatY} />
  </div>;
  return url ? <img src={url} alt={name} style={enlarged ? { maxWidth: "100%", maxHeight: "60vh", objectFit: "contain" } : { width: 100, height: 72, objectFit: "contain" }} />
    : <span className="text-muted">{failed ? "Képhiba" : imageKey || file ? "Betöltés…" : "Nincs kép"}</span>;
}

export function ImagePicker({ value, onChange, disabled, label }) {
  const [error, setError] = useState("");
  return <div className="d-flex align-items-center flex-wrap gap-2">
    <MillingImage imageKey={value.imageKey} file={value.file} name={value.name} />
    <label>{label || "Kép (PNG/JPG, max. 10 MB)"}
      <input className="form-control" type="file" accept="image/png,image/jpeg" disabled={disabled}
        onChange={(event) => {
          const file = event.target.files[0];
          event.target.value = "";
          if (!file) return;
          if (!["image/png", "image/jpeg"].includes(file.type) || file.size > 10 * 1024 * 1024) {
            setError("Legfeljebb 10 MB-os PNG/JPG képet válassz."); return;
          }
          setError(""); onChange({ ...value, file });
        }} />
    </label>
    {(value.file || value.imageKey) && <button type="button" className="btn btn-outline-secondary btn-sm" disabled={disabled}
      onClick={() => { setError(""); onChange({ ...value, file: null, imageKey: "" }); }}>Kép eltávolítása</button>}
    {(value.file || value.imageKey) && <MillingContourEditor mode="image" value={value} onChange={onChange} disabled={disabled} />}
    {(value.file || value.imageKey) && <div className="d-flex gap-2 flex-wrap">
      {[['imageWidthMm','A képen lévő front szélessége (mm)'],['imageHeightMm','A képen lévő front magassága (mm)']].map(([field,title]) =>
        <label key={field}>{title}<input className="form-control" type="number" min="0.01" max="10000" step="any" disabled={disabled}
          value={value[field] ?? ''} onChange={(e)=>onChange({...value,[field]:e.target.value===''?null:Number(e.target.value)})} /></label>)}
      <small>A szélső keret méretének megtartásához. Üresen a már feldolgozott DXF méretét használjuk.</small>
    </div>}
    {error && <span role="alert" className="text-danger">{error}</span>}
  </div>;
}
